import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IngredientsServices } from "../../services";
import { Globals } from "../../../../globals";
import { ProvidersServices } from "../../../providers/services";
import { StaticsServices } from '../../../services/statics';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { AngularFirestore } from 'angularfire2/firestore';
import firebase from 'firebase';

/**
 * Generated class for the IngredientCreateStockPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-add-stock',
  templateUrl: 'ingredient-add-stock.html',
})
export class IngredientAddStockPage {

  public firestore;
  public form: FormGroup;
  ingredient_name: any;
  ingredient_uid: string;
  update_state: boolean = false;
  value_changes: any;

  show_alert: boolean = true;
  old_stock: number = 0;

  ingredient: any = {};
  ingredients = [];

  units: number = 0;
  stock_final: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientServices: IngredientsServices,
    public fb: FormBuilder,
    public globals: Globals,
    public providersServices: ProvidersServices,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    private analyticsService: AnalyticsServices,
    public afs: AngularFirestore) {
    this.firestore = firebase.firestore();


    //Params
    this.update_state = this.navParams.get('update_state');
    this.ingredient_name = this.navParams.get('ingredient_name');
    this.ingredient_uid = this.navParams.get('ingredient_uid');

    this.ingredient.foodcost = [];

    this.startData();

    this.stock_final = this.navParams.get('stock');

    //Si hacemos update adamptamos la informacion
    if (this.update_state) {
      this.old_stock = this.navParams.get('stock');

      this.form = fb.group({
        measurement: [this.navParams.get('measurement')],
        stock: [this.navParams.get('stock')],
        stock_alert: [this.units],
        stock_max: [this.stock_final],
        sub_recipe: [false],
        reason: '',
        reason_desc: '',
      });
    } else {
      this.form = fb.group({
        measurement: ['kg'],
        stock: [0],
        stock_alert: [0],
        stock_max: [0],
        sub_recipe: [false],
        reason: 'new_ingredient',
        reason_desc: '',
      });
    }
  }

  sendDataChangeStock() {
    var extra = {
      "stock": this.form.value.stock,
      "min_stock": this.form.value.stock_alert,
      "max_stock": this.form.value.stock_max,
      "reason": this.form.value.reason,
      "reason_desc": this.form.value.reason_desc,
    };
    this.globals.dataSet('ingredient_stock', this.ingredient_name, '', JSON.stringify(extra));
  }

  async sendStockAnalytics(stock) {
    this.analyticsService.sendStock(stock);
  }

  async startData() {
    //get ingredient
    await this.firestore.collection('ingredients').doc(this.ingredient_uid).get().then((doc) => {
      if (doc.exists) {
        this.ingredient = doc.data();
        this.ingredient.UID = doc.id;
      }
    }).catch(function (error) { });

    //mirar el foodcost
    for (let ingr_fc_key in this.ingredient.foodcost) {
      //añadir la variable que marca si el stock es suficiente
      this.ingredient.foodcost[ingr_fc_key].stock_suficiente = true;
      if (this.ingredient.foodcost[ingr_fc_key].measurement_static == 'gr') {
        this.ingredient.foodcost[ingr_fc_key].measurement = 'kg'
      } else if (this.ingredient.foodcost[ingr_fc_key].measurement_static == 'ml') {
        this.ingredient.foodcost[ingr_fc_key].measurement = 'l'
      } else {
        this.ingredient.foodcost[ingr_fc_key].measurement = this.ingredient.foodcost[ingr_fc_key].measurement_static
      }
    }

    //recuperar los ingredientes
    this.firestore.collection('ingredients').where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get().then(snapshot => {
      snapshot.forEach(doc => {
        var _doc = doc.data();
        _doc.UID = doc.id;
        this.ingredients.push(_doc);

        //si el ingredient esta en el stock del ingredient 
        //find index del ingredient en el stock del ingredient
        var index = this.ingredient.foodcost.findIndex(x => x.uid == _doc.UID);
        if (index != -1) {
          this.ingredient.foodcost[index].stock_ = _doc.stock;
          this.ingredient.foodcost[index].stock_post = _doc.stock;
        }
      });
    });
  }

  async onChange(units) {
    this.units = parseFloat(units);

    //sumar al stock actual valor maximo
    this.form.value.stock_max = parseFloat(this.form.value.stock) + parseFloat(units);

    this.stock_final = this.form.value.stock_max;

    //actualizar el formulario
    this.form.patchValue({
      stock_max: this.stock_final
    });

    for (let product_fc_key in this.ingredient.foodcost) {
      //restamos el stock de los ingredientes del plato
      await this.deductStockIngredient(this.ingredients, this.ingredient.foodcost[product_fc_key], this.ingredient.real_weight, this.globals.restaurant, false);
    }
  }

  async addStockWfoodcost() {
    if (this.units != 0) {
      //funcion que añade stock en el producto con escandallo
      for (let product_fc_key in this.ingredient.foodcost) {
        await this.deductStockIngredient(this.ingredients, this.ingredient.foodcost[product_fc_key], this.ingredient.real_weight, this.globals.restaurant, true);
      }
      var _stock = 0;
      var units = this.units;

      //get ingredient firestore
      await this.firestore.collection('ingredients').doc(this.ingredient_uid).get().then((doc) => {
        if (doc.exists) {
          _stock = parseFloat(doc.data().stock);
        }
      });

      //añadir stock
      _stock = _stock + units;

      //actualizar el stock del ingrediente
      this.firestore.collection('ingredients').doc(this.ingredient.UID).update({
        stock: _stock
      });
      this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], this.ingredient.UID);
      //lanzar bigquery del elemento que añadimos stock
      var stock = {
        "elements": [{
          "uid_element": this.ingredient.UID,
          "name": this.ingredient.name,
          "price": Math.abs((this.ingredient.price_static / this.ingredient.real_weight) * (_stock - this.old_stock)), //Siempre numero positivo
          "quantity": (_stock - this.old_stock),
          "measurement": this.ingredient.measurement,
          "modifier": "",
        }],
        "uid": this.globals.restaurant_uid,
        "date": new Date(),
        "type": "stock",
        "comment": this.form.value.reason_desc,
        "type_type": "MANUAL",
        "delivery_uid": null
      };
      this.sendStockAnalytics(stock);
      this.navCtrl.pop();
    }
  }

  async deductStockIngredient(ingredients, foodcost_element, foodcost_parts, restaurant, restar_stock) {
    var index_ingr = ingredients.findIndex(x => x.UID == foodcost_element.uid);

    //comprovar que  ingr existe
    if (index_ingr >= 0) { //caso product existe
      //comprobar si es un ingrediente basico o compuesto
      //if (!ingr.sub_recipe) {//basico
      //update
      var _ingr;
      //consulta firebase para recuperar el ingrediente
      await this.firestore.collection('ingredients').doc(foodcost_element.uid).get()
        .then(doc => {
          if (doc.exists) {
            _ingr = doc.data();
            _ingr.UID = doc.id;
          }
        })
        .catch(err => { });

      var _stock = await this.calculateMeasurements(_ingr.measurement, _ingr.stock, (this.divideQuantityFoodcostparts(foodcost_parts, foodcost_element.quantity_gross) * this.units));

      var index = this.ingredient.foodcost.findIndex(x => x.uid == _ingr.UID);

      this.ingredient.foodcost[index].measurement = _ingr.measurement

      //comprobar que queda stock suficiente
      if (_stock >= 0) {
        this.ingredient.foodcost[index].stock_suficiente = true;
        this.ingredient.foodcost[index].stock_post = _stock;

        //actualizar el stock
        if (restar_stock) {
          await this.firestore.collection('ingredients').doc(foodcost_element.uid).update({
            'stock': _stock,
          }).then(() => {
            ingredients[index_ingr].stock = _stock;
          });
          this.analyticsService.trackingExpStock('deduct_stock', this.globals.tracking_exp['deduct_stock'], foodcost_element.uid);
        }
      } else {
        //find index this.product.foodcost 
        _stock = 0;
        //this.product.foodcost.stock_suficiente = false
        this.ingredient.foodcost[index].stock_suficiente = false;
        this.ingredient.foodcost[index].stock_post = _stock;

        //crear una notificacion de stock insuficiente
        if (_ingr.stock != 0) {
          if (restar_stock) {
            await this.firestore.collection('ingredients').doc(foodcost_element.uid).update({
              'stock': 0,
            }).then(() => {
              ingredients[index_ingr].stock = 0;
            });
          }
        }
        //notifMinStock(_stock, ingredients[index_ingr].stock_alert, getNameIngredientLang(ingredients[index_ingr], restaurant.lang), restaurant);
        //}
      }
      //lanzar bigquery de los elementos que quitamos stock
      if (restar_stock) {
        var stock = {
          "elements": [{
            "uid_element": foodcost_element.uid,
            "name": foodcost_element.name_static,
            "price": Math.abs(foodcost_element.price_notax * (foodcost_element.stock_post - foodcost_element.stock_)), //Siempre numero positivo
            "quantity": (foodcost_element.stock_post - foodcost_element.stock_),
            "measurement": foodcost_element.measurement,
            "modifier": this.ingredient.name,
          }],
          "uid": this.globals.restaurant_uid,
          "date": new Date(),
          "type": "stock",
          "comment": this.form.value.reason_desc,
          "type_type": "MANUAL",
          "delivery_uid": null
        };
        this.sendStockAnalytics(stock);
      }
    }
  }

  calculateMeasurements(measurement, stock, minus_stock) {
    //multiplicar minus_stock(lo que se resta) por las units(unidades de ese elemento)
    var return_stock = 0;
    if (measurement === 'kg' || measurement === 'l') {
      //kg l
      var stock_grams_ml = stock * 1000;
      var total = stock_grams_ml - parseFloat(minus_stock);

      return_stock = total / 1000;
    } else if (measurement === 'ud.') {
      return_stock = stock - minus_stock;
    } else {
      return_stock = parseFloat(stock) - parseFloat(minus_stock);
    }

    return parseFloat(return_stock.toFixed(3));
  }

  checkIfStockNegative(stock) {
    if (stock >= 0) {
      return parseFloat(stock);
    } else {
      return 0;
    }
  }

  divideQuantityFoodcostparts(parts, quantity) {
    return parseFloat(quantity) / parseFloat(parts);
  }
}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-add-stock/ingredient-add-stock.ts